const d3 = require('d3-selection');

d3.selection.prototype.appendSelect = function (el, cls) {
    const selected = cls
      ? this.select(`${el}.${cls.split(' ').join('.')}`)
      : this.select(el);
    if (selected.empty()) {
      return cls ? this.append(el).classed(cls, true) : this.append(el);
    }
    return selected;
  };
  
  module.exports = d3;